module.exports = __webpack_public_path__ + "static/media/ARIALMTEXTRABOLD.42a9968b.woff";